var matches = require('matches-selector')

module.exports = function (element, selector, checkYoSelf) {
  var parent = checkYoSelf ? element : element.parentNode

  while (parent && parent !== document) {
    if (matches(parent, selector)) return parent;
    parent = parent.parentNode
  }
}



//////////////////
// WEBPACK FOOTER
// /home/jtsymon/code/govhack-2017-game/node_modules/closest/index.js
// module id = 273
// module chunks = 0